/** The Polar checkout link, or `null` when none is configured. There is no
 *  hardcoded fallback on purpose — a missing `NEXT_PUBLIC_POLAR_CHECKOUT_URL`
 *  should hide the checkout CTA, never send buyers to some other product's
 *  checkout. Callers must handle `null`. */
export function getPolarCheckoutUrl(): string | null {
  return process.env.NEXT_PUBLIC_POLAR_CHECKOUT_URL || null;
}

/** Append the PostHog distinct_id as Polar's `reference_id` (propagates into
 *  order/subscription metadata for closed-loop attribution). No-ops for non-Polar hrefs. */
export function withCheckoutReference(href: string, distinctId: string): string {
  try {
    const u = new URL(href);
    if (u.hostname !== 'buy.polar.sh') return href;
    if (!u.searchParams.has('reference_id')) u.searchParams.set('reference_id', distinctId);
    return u.toString();
  } catch { return href; }
}



